import { render, staticRenderFns } from "./companyReport.vue?vue&type=template&id=230c1d8e&scoped=true"
import script from "./companyReport.vue?vue&type=script&lang=js"
export * from "./companyReport.vue?vue&type=script&lang=js"
import style0 from "./companyReport.vue?vue&type=style&index=0&id=230c1d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c1d8e",
  null
  
)

export default component.exports